/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { LicenseType } from '../models/license-type';
@Injectable({
  providedIn: 'root',
})
class LicenseTypeService extends __BaseService {
  static readonly LicenseTypeCreateLicenseTypePath = '/api/LicenseType/CreateLicenseType';
  static readonly LicenseTypeGetAllLicenseTypesByProductIdPath = '/api/LicenseType/GetAllLicenseTypesByProductId';
  static readonly LicenseTypeUpdateLicenseTypeByIdPath = '/api/LicenseType/UpdateLicenseTypeById';
  static readonly LicenseTypeDeleteLicenseTypeByIdPath = '/api/LicenseType/DeleteLicenseTypeById';
  static readonly LicenseTypeGetLicenseTypeByIdPath = '/api/LicenseType/GetLicenseTypeById';
  static readonly LicenseTypeGetAllDeletedLicenseTypeByProductIdPath = '/api/LicenseType/GetAllDeletedLicenseTypeByProductId';
  static readonly LicenseTypeRestoreDeletedLicenseTypeByIdPath = '/api/LicenseType/RestoreDeletedLicenseTypeById';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `LicenseTypeService.LicenseTypeCreateLicenseTypeParams` containing the following parameters:
   *
   * - `model`:
   *
   * - `productId`:
   */
  LicenseTypeCreateLicenseTypeResponse(params: LicenseTypeService.LicenseTypeCreateLicenseTypeParams): __Observable<__StrictHttpResponse<LicenseType>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.model;
    if (params.productId != null) __params = __params.set('productId', params.productId.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/LicenseType/CreateLicenseType`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<LicenseType>;
      })
    );
  }
  /**
   * @param params The `LicenseTypeService.LicenseTypeCreateLicenseTypeParams` containing the following parameters:
   *
   * - `model`:
   *
   * - `productId`:
   */
  LicenseTypeCreateLicenseType(params: LicenseTypeService.LicenseTypeCreateLicenseTypeParams): __Observable<LicenseType> {
    return this.LicenseTypeCreateLicenseTypeResponse(params).pipe(
      __map(_r => _r.body as LicenseType)
    );
  }

  /**
   * @param productId undefined
   */
  LicenseTypeGetAllLicenseTypesByProductIdResponse(productId?: number): __Observable<__StrictHttpResponse<Array<LicenseType>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (productId != null) __params = __params.set('productId', productId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/LicenseType/GetAllLicenseTypesByProductId`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<LicenseType>>;
      })
    );
  }
  /**
   * @param productId undefined
   */
  LicenseTypeGetAllLicenseTypesByProductId(productId?: number): __Observable<Array<LicenseType>> {
    return this.LicenseTypeGetAllLicenseTypesByProductIdResponse(productId).pipe(
      __map(_r => _r.body as Array<LicenseType>)
    );
  }

  /**
   * @param model undefined
   */
  LicenseTypeUpdateLicenseTypeByIdResponse(model: LicenseType): __Observable<__StrictHttpResponse<LicenseType>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = model;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/LicenseType/UpdateLicenseTypeById`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<LicenseType>;
      })
    );
  }
  /**
   * @param model undefined
   */
  LicenseTypeUpdateLicenseTypeById(model: LicenseType): __Observable<LicenseType> {
    return this.LicenseTypeUpdateLicenseTypeByIdResponse(model).pipe(
      __map(_r => _r.body as LicenseType)
    );
  }

  /**
   * @param licenseTypeId undefined
   */
  LicenseTypeDeleteLicenseTypeByIdResponse(licenseTypeId?: number): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (licenseTypeId != null) __params = __params.set('licenseTypeId', licenseTypeId.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/LicenseType/DeleteLicenseTypeById`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param licenseTypeId undefined
   */
  LicenseTypeDeleteLicenseTypeById(licenseTypeId?: number): __Observable<Blob> {
    return this.LicenseTypeDeleteLicenseTypeByIdResponse(licenseTypeId).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param licenseTypeId undefined
   */
  LicenseTypeGetLicenseTypeByIdResponse(licenseTypeId?: number): __Observable<__StrictHttpResponse<LicenseType>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (licenseTypeId != null) __params = __params.set('licenseTypeId', licenseTypeId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/LicenseType/GetLicenseTypeById`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<LicenseType>;
      })
    );
  }
  /**
   * @param licenseTypeId undefined
   */
  LicenseTypeGetLicenseTypeById(licenseTypeId?: number): __Observable<LicenseType> {
    return this.LicenseTypeGetLicenseTypeByIdResponse(licenseTypeId).pipe(
      __map(_r => _r.body as LicenseType)
    );
  }

  /**
   * @param productId undefined
   */
  LicenseTypeGetAllDeletedLicenseTypeByProductIdResponse(productId?: number): __Observable<__StrictHttpResponse<Array<LicenseType>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (productId != null) __params = __params.set('productId', productId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/LicenseType/GetAllDeletedLicenseTypeByProductId`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<LicenseType>>;
      })
    );
  }
  /**
   * @param productId undefined
   */
  LicenseTypeGetAllDeletedLicenseTypeByProductId(productId?: number): __Observable<Array<LicenseType>> {
    return this.LicenseTypeGetAllDeletedLicenseTypeByProductIdResponse(productId).pipe(
      __map(_r => _r.body as Array<LicenseType>)
    );
  }

  /**
   * @param licenseTypeId undefined
   */
  LicenseTypeRestoreDeletedLicenseTypeByIdResponse(licenseTypeId?: number): __Observable<__StrictHttpResponse<LicenseType>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (licenseTypeId != null) __params = __params.set('licenseTypeId', licenseTypeId.toString());
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/LicenseType/RestoreDeletedLicenseTypeById`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<LicenseType>;
      })
    );
  }
  /**
   * @param licenseTypeId undefined
   */
  LicenseTypeRestoreDeletedLicenseTypeById(licenseTypeId?: number): __Observable<LicenseType> {
    return this.LicenseTypeRestoreDeletedLicenseTypeByIdResponse(licenseTypeId).pipe(
      __map(_r => _r.body as LicenseType)
    );
  }
}

module LicenseTypeService {

  /**
   * Parameters for LicenseTypeCreateLicenseType
   */
  export interface LicenseTypeCreateLicenseTypeParams {
    model: LicenseType;
    productId?: number;
  }
}

export { LicenseTypeService }
